<template>
  <button
    class="uk-button action-button"
    :disabled="disabled"
    :class="{
      [`uk-button-${color}`]: true
    }"
    :style="{ width: width + 'px' }"
  >
    {{ title }}
  </button>
</template>
<style lang="scss" scoped>
.uk-button {
  border-radius: 5px !important;
  min-width: 100px;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class TableActionButton extends Vue {
  @Prop({ type: String }) title = "Button";
  @Prop({ type: String }) color: "primary" | "default" | "secodary" | "danger" = "default";
  @Prop({ type: Number }) width = 100;
  @Prop({ type: Boolean }) disabled?: boolean = false;
}
</script>
